import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';
import { SendComponent } from './send.component';
import { SmashPromotionModule } from '@app/shared/modules/smash-promotion/smash-promotion.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SmashThemeModule } from '@app/shared/modules/smash-theme/smash-theme.module';

@NgModule({
  declarations: [
    SendComponent,
    UploadProgressComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    SmashFormsModule,
    SmashPromotionModule,
    SmashThemeModule,
  ],
  exports: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

})
export class SendModule { }
